import dynamic from 'next/dynamic';

import styles from './landing.module.css';

import clsxm from '@/lib/clsxm';

import LightMarkdown from './LightMarkdown';

// Loaded only for text that needs it (maths or code), so most template pages
// never download its highlighter and KaTeX.
const MarkdownBlock = dynamic(() => import('@/components/Chat/MarkdownBlock'));

/**
 * Math (the solver presets' `<<|…|>>` and TeX delimiters) and fenced code
 * need the chat renderer; everything else reads fine as light Markdown.
 */
const NEEDS_FULL_RENDERER = /<<\||```|\$\$|\\\(|\\\[/;

export default function RichText({
  text,
  className,
  userContent = true,
}: {
  text: string;
  className?: string;
  userContent?: boolean;
}) {
  if (NEEDS_FULL_RENDERER.test(text)) {
    return (
      <div
        className={clsxm(
          'messages text-[15px] text-[#3c3c52] dark:text-[#c4c4da]',
          styles.full,
          className,
        )}
      >
        <MarkdownBlock message={text.replace(/\n/g, '  \n').trim()} />
      </div>
    );
  }
  return (
    <LightMarkdown
      text={text}
      className={className}
      userContent={userContent}
    />
  );
}
